declare const __APP_VERSION__: string;

const env = import.meta.env;

const projectId = (env.VITE_SANITY_PROJECT_ID as string | undefined) || '';

/** Sede del build: cada sede muestra SOLO sus proyectos (campo `sede` en Sanity) */
export type Sede = 'arequipa' | 'lima';
const sede = ((env.VITE_SEDE as string | undefined) || 'arequipa') as Sede;

export const CONFIG = {
  sede,
  /** Documento de configuración del tótem de esta sede en Sanity */
  settingsId: sede === 'arequipa' ? 'settings' : `settings-${sede}`,
  appVersion: typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev',
  source: ((env.VITE_CONTENT_SOURCE as string | undefined) || (projectId ? 'sanity' : 'demo')) as 'sanity' | 'demo',
  sanity: {
    projectId,
    dataset: (env.VITE_SANITY_DATASET as string | undefined) || 'production',
    apiVersion: (env.VITE_SANITY_API_VERSION as string | undefined) || '2025-02-19',
  },
  cloudinaryCloud: (env.VITE_CLOUDINARY_CLOUD as string | undefined) || '',
  sentryDsn: (env.VITE_SENTRY_DSN as string | undefined) || '',
  heartbeatUrl: (env.VITE_HEARTBEAT_URL as string | undefined) || '/api/heartbeat',
  pollMs: Math.max(1, Number(env.VITE_POLL_MINUTES || 1)) * 60_000,
  heartbeatMs: 5 * 60_000,

  /** Descargas simultáneas (requisito: máximo 2) */
  maxParallel: 2,
  /** Intentos por archivo antes de abortar la versión (backoff exponencial 1s,2s,4s,8s,16s) */
  maxAttempts: 6,
  fileTimeoutMs: 90_000,
  requestTimeoutMs: 15_000,

  /** Segundos que dura el aviso "¿Sigues ahí?" antes de volver al reposo */
  idlePromptSeconds: 10,
  defaultIdleSeconds: 60,
  /** Ken Burns */
  slideMs: 8000,
  fadeMs: 1200,
  /** Recarga preventiva (24/7): al entrar en reposo si la app lleva más de N horas viva */
  softReloadHours: 20,
};
